export default {
    icon: "el-icon-search",
    title: "搜索框",
    name: "headerSerch",
    timestamp: new Date().getTime(),
    setUp: {
        tabVal: 0
    },
    bgColor: {
        title: "背景颜色(渐变)",
        name: "bgColor",
        default: [
            {
                item: "#F62C2C"
            },
            {
                item: "#F96E29"
            }
        ],
        color: [
            {
                item: "rgba(29,176,252,1)"
            },
            {
                item: "rgba(64,209,244,1)"
            }
        ]
    },
    boxStyle: {
        title: "边框样式",
        name: "boxStyle",
        type: 0,
        list: [
            {
                val: "圆角",
            },
            {
                val: "直角",
            }
        ]
    },
    txtStyle: {
        title: "文本位置",
        name: "txtStyle",
        type: 1,
        list: [
            {
                val: "居左",
            },
            {
                val: "居中",
            },
            {
                val: "居右",
            }
        ]
    },
    prConfig: {
        title: "背景边距",
        val: 8,
        min: 0
    },
    mbConfig: {
        title: "页面间距",
        val: 0,
        min: 0
    },
    logoConfig: {
        type: 1,
        header: "设置logo",
        title: "",
        url: ""
    },
    id: new Date().getTime()
}